
export enum ColchesterRecordType  {      
        Monument = "mon",
        Event = "event",
        Source = "source",
        Designation= "desig"
}  

export enum  ColchesterRecordSubType  {   
    ConservationArea = "COA",
    ListedBuilding = "LB",
    RegisteredParksAndGardens = "RG",
    ScheduledMonument= "SAM",   
    LocalList = "LL"
}  
